export const GOING_NOT_GOING = {
  GOING: 'Going',
  NOT_GOING: 'NotGoing',
} as const;
